import { FC } from 'react';
import clsx from 'clsx';
import { IDropdownMenu } from '../../types';
import styles from './styles.module.css';

const DropdownMenu: FC<IDropdownMenu> = (props) => {

  const {
    id,
    children,
    ...rest
  } = props;

  return (
    <div className="dropdown-menu" id={id} role="menu" {...rest}>
      <div className={clsx('dropdown-content', styles.content)}>
        {children}
      </div>
    </div>
  );

};

export default DropdownMenu;
